import '../scss/account.scss';
import '../utils/addresses';
import '../components/account-menu';
import '../components/my-subscriptions';
import '../components/product-registration';
import '../components/wishlistSelectInterceptor';
import { getDate, sendDate } from '../components/updatecustomer';
import { getBirthdate } from '../services/klaviyo';

getDate();
sendDate();

const sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay));

async function validateBirthdate(email, step = 1) {
  const date = await getBirthdate(email);
  if (date || step > 5) {
    return date;
  } else {
    await sleep(1000);
    return await validateBirthdate(email, step + 1);
  }
}

document.addEventListener('DOMContentLoaded', async () => {
  const birthInput = document.querySelector('#Birthdate');
  if (birthInput) {
    const bithDateContainer = document.querySelector('.birthdate');
    const date = await validateBirthdate(birthInput.dataset.email);
    if (date) {
      bithDateContainer.querySelector('span').innerHTML = date;
    } else {
      bithDateContainer.classList.add('hidden');
      birthInput.parentNode.classList.remove('hidden');
    }
  }
});
